webpackJsonp([24],Array(32).concat([
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(88),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1962e839",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(89),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2231c14b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ls__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_qr__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_qr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_qr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_meta__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__paths__ = __webpack_require__(47);








var options = {
  namespace: 'pgbcowork_'
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_ls___default.a, options);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_qr___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_meta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__paths__["a" /* default */])),
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var position = {};
    if (to.hash) {
      position.offset = { y: 0 };
      position.selector = to.hash;

      return position;
    }
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(87),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppBody__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppFooter__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CloseModal__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CloseModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CloseModal__);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default.a,
    AppBody: __WEBPACK_IMPORTED_MODULE_1__components_AppBody___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_2__components_AppFooter___default.a,
    CloseModal: __WEBPACK_IMPORTED_MODULE_3__components_CloseModal___default.a
  },
  metaInfo: {
    title: 'Coworking Progressbar in Bratislava',
    titleTemplate: '%s | Place to work 🙌'
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-body',
  components: {
    ProgressbarLogoRefresh: __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue___default.a
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer',
  data: function data() {
    return {
      currentYear: new Date().getFullYear(),
      contacts: [{ url: 'https://t.me/coworkprogressbar', title: 'Telegram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["a" /* faTelegram */] }, { url: 'mailto:info@progressbar.sk', title: 'info@progressbar.sk' }, { url: 'https://m.me/progressbar', title: 'Messenger', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["b" /* faFacebookMessenger */] }],
      socials: [{ url: 'https://www.facebook.com/progressbar', title: 'Facebook', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["c" /* faFacebook */] }, { url: 'https://twitter.com/progressbarsk', title: 'Twitter', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["d" /* faTwitterSquare */] }, { url: 'https://www.youtube.com/channel/UCpun3Ro3aUJPoFVZwgqd98A', title: 'Youtube', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["e" /* faYoutubeSquare */] }, { url: 'https://www.instagram.com/progressbar_sk', title: 'Instagram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["f" /* faInstagram */] }, { url: 'https://github.com/Progressbar', title: 'Github', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["g" /* faGithub */] }, { url: 'https://t.me/coworkprogressbar', title: 'Telegram', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["a" /* faTelegram */] }, { url: 'https://m.me/progressbar', title: 'Messenger', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["b" /* faFacebookMessenger */] }],
      internals: [{ url: 'https://github.com/Progressbar/Progressbar-Improvement-Proposal/issues', title: 'Progressbar Improvement Proposal', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["g" /* faGithub */] }, { url: 'https://github.com/Progressbar/space-map/blob/master/map.png', title: 'Blueprint', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["g" /* faGithub */] }, { url: 'https://github.com/Progressbar/culture', title: 'Culture', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["g" /* faGithub */] }, { url: 'https://github.com/Progressbar/presskit', title: 'Presskit', icon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_brands_svg_icons__["g" /* faGithub */] }],
      projects: [{ url: 'https://github.com/Progressbar/diybiobratislava', title: 'DIYBio Bratislava', icon: '' }, { url: 'https://noodles.digital', title: 'Noodles Digital', icon: '' }],
      // TODO: ADD HERE MAP LINK
      // TODO: ADD APPLE MAP LINK
      mapUrls: [{ url: 'https://www.openstreetmap.org/node/1096120193', title: 'Open Street Map', icon: '' }, { url: 'https://goo.gl/maps/piJwx6AAB762', title: 'Google Maps', icon: '' }]
    };
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProgressbarLogoIcon_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProgressbarLogoIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ProgressbarLogoIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',
  components: {
    ProgressbarLogoRefresh: __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoRefresh_vue___default.a,
    ProgressbarLogoIcon: __WEBPACK_IMPORTED_MODULE_1__components_ProgressbarLogoIcon_vue___default.a
  },
  props: {
    showLogo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      socials: [{ url: 'https://t.me/coworkprogressbar', title: 'Telegram', icon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons__["a" /* faTelegram */] }],
      href: {
        fixdesk: 'https://goo.gl/maps/sYsSt6e1uBE2',
        eventspace: 'https://goo.gl/maps/SghsZJzVPNs',
        coworkgroup: 'https://t.me/coworkprogressbar',
        eventsfb: 'https://www.facebook.com/pg/progressbar/events/',
        homesite: 'https://cowork.progressbar.sk'
      },
      showNav: false,
      MiscButtonIsActive: false
    };
  },

  methods: {
    toggleNav: function toggleNav() {
      this.showNav = !this.showNav;
    },
    redirectToUrl: function redirectToUrl(url) {
      this.toggleNav();
      window.open(url, '_blank').focus();
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoIcon_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoIcon_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CloseModal',
  components: {
    ProgressbarLogoIcon: __WEBPACK_IMPORTED_MODULE_0__components_ProgressbarLogoIcon_vue___default.a
  },
  data: function data() {
    return {
      isActive: true
    };
  },

  methods: {
    close: function close() {
      this.isActive = false;
    }
  }

});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'progressbar-logo-icon'
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'progressbar-logo-refresh'
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(34);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$api = {
  baseWebUrl: 'https://progressbar.sk/',
  pubConfig: 'pubConfig/',
  subscribers: 'status/',
  daydetails: 'daydetails/',
  newSubscriber: 'emailSubscribe/',
  verify: 'verify/',
  order: 'order/',
  orderCowork: 'orderCowork/',
  login: 'login/',
  logmein: 'logmein/',
  openDoor: 'openDoor/',
  openBlackDoor: 'openBlackDoor/'
};

if (false) {
  Vue.prototype.$api.base = 'http://localhost:8170/yangwao/progressbar-coweb/';
}

if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$api.base = 'https://yangwao.lib.id/progressbar-coweb@dev/';
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Page404 = function Page404() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 112));
};
var Podcast = function Podcast() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 114));
};
var Subscribe = function Subscribe() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 120));
};
var WeekPass = function WeekPass() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 123));
};
var CallForTheSponsors = function CallForTheSponsors() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 102));
};
var GiveUsReviewBooking = function GiveUsReviewBooking() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 110));
};
var GiveUsReviewAfterVisit = function GiveUsReviewAfterVisit() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 109));
};
var Calendar = function Calendar() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 101));
};
var PrivateOffice = function PrivateOffice() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 115));
};
var Crowdfunding = function Crowdfunding() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 105));
};
var FlexDesk = function FlexDesk() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 108));
};
var FixDesk = function FixDesk() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 107));
};
var Team = function Team() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 121));
};
var Network = function Network() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 119));
};
var Pay = function Pay() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 113));
};
var Residents = function Residents() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 117));
};
var ContactVenue = function ContactVenue() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 104));
};
var SilentPlace = function SilentPlace() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 118));
};
var MeetingRoom = function MeetingRoom() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 111));
};
var RentSpace = function RentSpace() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 116));
};
var Community = function Community() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 103));
};
var Video = function Video() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 122));
};
var DvePercenta = function DvePercenta() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 106));
};

var paths = [{
  path: '/',
  component: Subscribe
}, {
  path: '/coworking-bratislava',
  component: Subscribe
}, {
  path: '/meeting-room-cowork-bratislava',
  component: MeetingRoom
}, {
  path: '/rent-meeting-room-cowork-bratislava',
  component: MeetingRoom
}, {
  path: '/rent-meeting-room-coworking-bratislava',
  component: MeetingRoom
}, {
  path: '/rent-flexdesk-cowork-bratislava',
  component: FlexDesk
}, {
  path: '/rent-flex-desk-coworking-bratislava',
  component: FlexDesk
}, {
  path: '/rent-fixdesk-cowork-bratislava',
  component: FixDesk
}, {
  path: '/rent-fix-desk-coworking-bratislava',
  component: FixDesk
}, {
  path: '/fixdesk-cowork-bratislava',
  component: FixDesk
}, {
  path: '/fix-desk-cowork-bratislava',
  component: FixDesk
}, {
  path: '/rent-desk-cowork-bratislava',
  component: FixDesk
}, {
  path: '/day-week-pass-coworking-bratislava',
  component: WeekPass
}, {
  path: '/call-for-the-sponsors',
  component: CallForTheSponsors
}, {
  path: '/rent-a-space-in-bratislava',
  component: RentSpace
}, {
  path: '/rent-a-space',
  component: RentSpace
}, {
  path: '/space-for-rent',
  component: RentSpace
}, {
  path: '/venue',
  component: RentSpace
}, {
  path: '/give-us-review-thanks',
  component: GiveUsReviewAfterVisit
}, {
  path: '/give-us-review-thanks/:coworkerName',
  component: GiveUsReviewAfterVisit
}, {
  path: '/free-daypass-thanks/:coworkerName',
  component: GiveUsReviewBooking
}, {
  path: '/pay',
  component: Pay
}, {
  path: '/calendar',
  component: Calendar
}, {
  path: '/network',
  component: Network
}, {
  path: '/our-residents',
  component: Residents
}, {
  path: '/podcast',
  component: Podcast
}, {
  path: '/contact',
  component: ContactVenue
}, {
  path: '/contact-venue',
  component: ContactVenue
}, {
  path: '/team',
  component: Team
}, {
  path: '/silent-place-to-work-in-bratislava',
  component: SilentPlace
}, {
  path: '/place-for-your-community-meetup-in-bratislava',
  component: Community,
  name: Community
}, {
  path: '/video',
  component: Video
}, {
  path: '/dvepercenta',
  component: DvePercenta
}, {
  path: '/crowdfunding',
  component: Crowdfunding
}, {
  path: '/rent-private-office-bratislava',
  component: PrivateOffice
}, {
  path: '*',
  component: Page404
}];

/* harmony default export */ __webpack_exports__["a"] = (paths);
// module.exports = { default: paths }

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(91),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c6037f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(92),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7207c16b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(93),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d98bb546",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('close-modal'), _vm._v(" "), _c('app-body'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    attrs: {
      "src": "/static/img/icons/android-launchericon-144-144.png",
      "alt": "coworking bratislava progressbar logo blockchain"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "aria-label": "Progressbar logo",
      "alt": "Progressbar logo",
      "viewBox": "0 0 328.5 123",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('title', [_vm._v("Progressbar logo")]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": " M 11 120 L 2 111 L 2 48 L 29 48 L 29 66 L 20 75 L 11 75",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 38 75 L 38 57 L 47 48 L 56 48",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 65 57 L 56 66 L 56 84 L 74 84 L 83 75 L 83 57 L 65 57 Z ",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 110 120 L 119 111 L 119 48 L 92 48 L 92 66 L 101 75 L 110 75",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 128 75 L 128 57 L 137 48 L 146 48",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 164 84 L 146 84 L 146 66 L 155 57 L 173 57 L 173 66 L 164 75",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 182 84 L 191 84 L 200 75",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 200 75 L 182 57 L 191 48 L 200 48",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 209 84 L 218 84 L 227 75 L 209 57 L 218 48 L 227 48",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 245 57 L 254 48 L 263 48 L 263 75 L 236 75 L 236 12 L 245 3",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 308 75 L 308 57 L 317 48 L 326 48",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": " M 272 48 L 290 48 L 299 57 L 299 75 L 272 75 L 272 66 L 281 57",
      "fill": "none",
      "stroke-width": "4",
      "stroke": "currentColor",
      "stroke-linejoin": "miter",
      "stroke-linecap": "square"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('progressbar-logo-icon')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "button is-black",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("I understand")])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Sorry, we are temporarily closed 😭")]), _vm._v(" "), _c('br'), _vm._v("\n              Corona crisis hit us, however we are doing our best to reopen soon!\n            ")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(['/'].includes(_vm.$route.path)) ? _c('section', {
    staticClass: "hero is-medium"
  }, [_c('div', {
    staticClass: "hero-bg"
  }, [_c('div', {
    staticClass: "hero-head"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('progressbar-logo-refresh')], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "button is-black is-large",
    attrs: {
      "to": "/rent-meeting-room-cowork-bratislava"
    }
  }, [_vm._v("\n                    🤝 Meeting Room\n                  ")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "button is-black is-large",
    attrs: {
      "to": "/video"
    }
  }, [_vm._v("🎥 Recordings\n                  ")])], 1)])])])])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "section section-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n                🌿 Your favourite coworking, 🍦 community space in\n                "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/gtmznEkBVGG2",
      "title": "location of progressbar"
    }
  }, [_vm._v("\n                downtown, Bratislava")]), _vm._v(" 🪐")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "button is-black is-large",
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork!",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("👩‍🔬 Join Coworking")])])
}]}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical is-3"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("🦠 Social")]), _vm._v(" "), _vm._l((_vm.socials), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  }), _c('br')], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical is-3"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("📍Find us on")]), _vm._v(" "), _c('p', [_vm._v("Progressbar Cowork & Hackerspace")]), _vm._v(" "), _c('p', [_vm._v("Dunajská 7495/14")]), _vm._v(" "), _c('p', [_vm._v("811 08, Bratislava")]), _vm._v(" "), _c('p', [_vm._v("Slovakia 🇸🇰")]), _vm._v(" "), _vm._l((_vm.mapUrls), function(item) {
    return _c('div', {
      key: item.url
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(item.title))])])
  })], 2), _vm._v(" "), _c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("👩‍💼 Services")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-flex-desk-coworking-bratislava"
    }
  }, [_vm._v("\n              Rent Flex Desk in Cowork\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-fix-desk-coworking-bratislava"
    }
  }, [_vm._v("\n              Rent Fix Desk in Cowork\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-meeting-room-coworking-bratislava"
    }
  }, [_vm._v("\n              Rent Meeting Room\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-private-office-bratislava"
    }
  }, [_vm._v("\n              Rent Private Office\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-a-space"
    }
  }, [_vm._v("\n              Rent Venue Space\n            ")])], 1)])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("🐚 History")]), _vm._v(" "), _c('ul', [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_vm._v("\n            If you think we are doing great thing\n            "), _c('ul', [_c('li', [_vm._v("\n                Join Our "), _c('router-link', {
    attrs: {
      "to": "/contact-venue"
    }
  }, [_vm._v("Coworking")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("You Can Support Us!")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/network"
    }
  }, [_vm._v("Be Our Proud Sponsor!")])], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "column is-6 has-text-right"
  }, [_c('small', {
    attrs: {
      "aria-label": "copyright"
    }
  }, [_vm._v("2010 - " + _vm._s(_vm.currentYear) + " © Progressbar Cowork")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("🌐 Network")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bitfwd.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/partners/bitfwd.png",
      "loading": "lazy",
      "alt": "community driven venture network"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://starfish.network/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/partners/Starfish_Logo_Horizontal Mission@4x.png",
      "loading": "lazy",
      "alt": "starfish mission san francisco blockchain space"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-theme": "dark",
      "data-height": "900",
      "href": "https://twitter.com/progressbarsk?ref_src=twsrc%5Etfw"
    }
  }, [_vm._v("Tweets by @progressbarsk\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n            We started as "), _c('a', {
    attrs: {
      "href": "https://progressbar.sk"
    }
  }, [_vm._v("first Slovak hackerspace")]), _vm._v(" back in June 2010,\n            this is our 4th place as we went through expansion and "), _c('a', {
    attrs: {
      "href": "https://progressbar.sk/calendar"
    }
  }, [_vm._v("held more than 1200 meetups")]), _vm._v(".\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n            In September 2017 we've considered to keep up our 💸 cashflow & our existence. We've started thinking about daily utilization.\n            "), _c('br'), _vm._v(" We came up with idea to open "), _c('a', {
    attrs: {
      "href": "https://t.me/coworkprogressbar"
    }
  }, [_vm._v("coworking")]), _vm._v(" in our hackerspace Progressbar in Bratislava.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('small', [_c('a', {
    attrs: {
      "href": "https://github.com/Progressbar/progressbar-coweb",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("/src")]), _vm._v(" (Feel free to help ❤️)")])])
}]}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "navbar is-black is-fixed-top has-shadow",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "progressbar-logo-container",
    attrs: {
      "to": "/"
    }
  }, [_c('progressbar-logo-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    attrs: {
      "role": "button",
      "aria-label": "menu",
      "aria-expanded": _vm.showNav
    },
    on: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showNav
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/place-for-your-community-meetup-in-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Community Meetups\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/rent-meeting-room-coworking-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Meeting Room\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/rent-flex-desk-coworking-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Rent Desk\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/rent-a-space-in-bratislava"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Rent Venue\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item is-size-4",
    attrs: {
      "exact-active-class": "is-active",
      "to": "/video"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showNav && _vm.toggleNav()
      }
    }
  }, [_vm._v("\n            Recordings\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown",
    class: {
      'is-active': _vm.showNav
    }
  }, [_c('a', {
    staticClass: "navbar-link is-size-4",
    on: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              Others\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown is-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/calendar"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              📅 Calendar\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/contact-venue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🛸 Contact\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/network"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🛰 Network\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/podcast"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🎙 Podcast\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/video"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🎥 Recordings\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/our-residents"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🏡 Residents\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/pay"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              💸 Support operations\n              ")]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/dvepercenta"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              📿 Donate 2 % of your taxes\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/call-for-the-sponsors"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🌈 Call for the Sponsors\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/crowdfunding"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              💰 Crowdfunding\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/give-us-review-thanks"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🥰 Give us Review\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item is-size-5",
    attrs: {
      "to": "/team"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNav()
      }
    }
  }, [_vm._v("\n              🙏 Team\n              ")])], 1)])], 1)])])])])
},staticRenderFns: []}

/***/ })
]),[46]);


// WEBPACK FOOTER //
// static/js/app.bd992e4349293a06c7c2.js